const CurrencyFormatter = new Intl.NumberFormat('es-PA', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

function toCents(str) {
    // Limpia espacios
    str = String(str).trim();
    if (!str) return 0;

    // Quita espacios
    str = str.replace(/\s/g, '');

    // Elimina separadores de miles tipo 1,000.00 o 1 000.00
    // (asumimos decimal con punto)
    str = str.replace(/,/g, '');

    // Si no hay punto decimal, agrega .00
    if (!str.includes('.')) str += '.00';

    const [intPartRaw, decPartRaw = ''] = str.split('.');

    // Evita NaN si intPart viene vacío
    const intPart = intPartRaw ? parseInt(intPartRaw, 10) : 0;

    // Normaliza decimales a 2 dígitos
    const dec = (decPartRaw + '00').slice(0, 2);
    const decPart = parseInt(dec, 10);

    return intPart * 100 + decPart;
}

export {
    CurrencyFormatter,
    toCents
}
